export default "__VITE_ASSET__B7x6h0IW__"